import type { YmdRoute } from '@yoummday/ymmd-router/dist/types';

export default <Record<string, YmdRoute>>{
	'/postpaid-dispo': {
		as: 'postpaid-dispo',
		module: () => import('.'),
		hasHeader: true,
		hasAsideNavigation: true,
	},
};
